import React from 'react'

import Dropdown from "./ReactDropdown";

export default class DropdownProgress extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option

	static get defaultProps()
	{
		let v =
			{
				mode: 'list',
				label: '',
				defaultValue: 0,
				emptyValue: 0,
				maxValue: 10,
				containerClassName: '',
			}

		return v;
	}
	
	constructor(props) 
	{
		super(props);
		
		if ( this.props.defaultValue == null || this.props.defaultValue > props.maxValue )
		{
			var def = 0 ;
		}
		else
		{
			def = this.props.defaultValue ;
		}

		// Create a state item here
		this.state = { dirty: false, currentValue: def, items: this.getStaticData() };
	}

	getStaticData()
	{
		const items = [
			{
				id: 0,
				desc: 'Select a Value'
			},
			{
				id: 1,
				desc: 'Emerging'
			},
			{
				id: 2,
				desc: 'Expected'
			},
			{
				id: 3,
				desc: 'Exceeded'
			}
		];

		return items ;
	}

	getdata( )
	{
		this.setState ( { items : this.getStaticData() } ) ;
	}

	findValueText ( value )
	{
		for (let i = 0; i < this.state.items.length; i++)
		{
			if ( this.state.items[i].id  == value )
			{
				return this.state.items[i].desc ;
			}
		}

		return '' ;
	}

	handleChange(e)
	{
		let val = e.target.value ;

		let text = this.findValueText ( val ) ;

		if ( this.props.onChange != null )
		{
			this.props.onChange ( value );
		}

		this.sendChangeNotification() ;

		this.setState ( {dirty: true, currentValue: val} ) ;
	}
	  
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0)
				{
					return false ;
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}

	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	isValid()
	{		
		return this.isValueValid ( this.getValue() ) ;
	}
	
    getValue()
    {
    	return this.state.currentValue ;
    }

	returnOption ( row )
	{
		return React.createElement ( 'option', {key: this.keyCount++, name: row.desc, value: row.id} , row.desc ) ;
	}

	optionList ()
	{
		return this.state.items.map(element =>
		{
			return this.returnOption ( element ) ;
		});
	}
    
    dropdown_select ( id )
    {
    	return React.createElement ( 'select', {key: this.keyCount++, value: this.state.currentValue, tabIndex: this.props.tabIndex, className: 'form-control', id: id , onChange: this.handleChange.bind(this)}, this.optionList() ) ;
    }

    render()
    {
		this.keyCount = 0 ;

		if ( this.props.readOnly != 'readonly' )
		{
			return React.createElement ( 'div', {key: this.keyCount++, className: this.props.containerClassName}, this.optionDropdown('list1')) ;
		}
		else
		{
			return React.createElement ( 'div', {key: this.keyCount++}, this.readOnlyField()) ;
		}
    }
};


